import React from "react";
import { Col, Divider, Modal, Row } from "antd";
import { useSelector } from "react-redux";
import { bailiffJobOpenPaymentSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
import { useJobDetailFlow } from "hook/bailiff/job/flow/useJobDetail";
import { useJobPayment } from "hook/bailiff/job/action/useJobPayment";
import TriggerJobPayment from "./trigger/trigger_job_payment";
import JobDeposit from "./component/job_deposit";
import JobTranscript from "./component/job_transcript";
// import JobDetail from "./component/job_detail";
import JobStepper from "./component/job_stepper";
import JobSupporter from "./component/job_supporter";
import JobSuccess from "./component/job_success";
//str

const OPTIONS = [
  {
    value: "waiting",
    title: "Đặt cọc 30% tiền vận hành AI",
  },
  {
    value: "waiting for deposit",
    title: "Đặt cọc 30% tiền vận hành AI",
  },
  {
    value: "transcript",
    title: "AI đang tiến hành biên dịch dữ liệu",
  },
  {
    value: "support",
    title: "AI đang tiến hành sửa lỗi",
  },
  {
    value: "approval",
    title: "File đã hoàn tất",
  },
];

const DialogPaymentJob = () => {
  // -------------------------- VAR -----------------------------
  const { flow } = useJobDetailFlow();
  const { handleClose } = useJobPayment();
  const exist = OPTIONS?.find((o) => o?.value === flow);
  const title = exist?.title;
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(bailiffJobOpenPaymentSelector);
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      width={700}
      onCancel={handleClose}
      title={title}
      open={open}
      footer={null}
    >
      <Divider />
      <Row gutter={[0, 30]} justify={"center"}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <JobStepper />
        </Col>
        <Col xl={24} lg={24} md={24} xs={24}>
          <JobDeposit />
          <JobTranscript />
          <JobSupporter />
          <JobSuccess />
        </Col>
      </Row>
      <TriggerJobPayment />
    </Modal>
  );
};
export default DialogPaymentJob;
